// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Quicksand-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Allerta-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/AllertaStencil-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Oswald-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/RobotoSlab-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/RobotoMono-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/AnnieUseYourTelescope-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Quicksand";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "Allerta";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: "Allerta Stencil";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: "Oswald";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "Roboto Slab";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
@font-face {
  font-family: "Roboto Mono";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
@font-face {
  font-family: "Annie use your telescope";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.note-configurator {
  display: flex;
  justify-content: space-between;
}
@media (max-width: 1024px) {
  .note-configurator {
    flex-wrap: wrap;
  }
}
.note-configurator.small .option-container__tabs .tab {
  width: 50%;
}
.note-configurator .option-container,
.note-configurator .note-container {
  flex: 0 0 auto;
  width: 48%;
}
@media (max-width: 1024px) {
  .note-configurator .option-container,
  .note-configurator .note-container {
    width: 100%;
    max-width: 530px;
    margin: 0 auto;
  }
}
.note-configurator .option-container {
  display: flex;
  flex-direction: column;
}
@media (max-width: 1024px) {
  .note-configurator .option-container {
    order: 2;
  }
}
.note-configurator .option-container__content {
  display: flex;
  flex: 0 0 auto;
}
.note-configurator .option-container__tabs {
  display: flex;
  flex: 0 0 auto;
  width: 100%;
  padding: 5px;
  border-radius: 100px;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1019607843);
  margin-bottom: 30px;
}
@media (max-width: 1024px) {
  .note-configurator .option-container__tabs {
    font-size: 13px;
  }
}
.note-configurator .option-container__tabs .tab {
  width: 33.334%;
  padding: 15px 0;
  border-radius: 100px;
  flex: 0 0 auto;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  color: #8066FF;
  transition: background 300ms ease, color 300ms ease;
  cursor: pointer;
}
.note-configurator .option-container__tabs .tab:hover {
  background: #EFF0F1;
}
.note-configurator .option-container__tabs .tab.active {
  background: #8066FF;
  color: #FFFFFF;
}
.note-configurator .option-container__menu {
  width: 150px;
  flex: 0 0 auto;
}
@media (max-width: 450px) {
  .note-configurator .option-container__menu {
    width: 120px;
  }
}
.note-configurator .option-container__menu .svg-toggle {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
}
.note-configurator .option-container__menu .menu-option {
  font-weight: 500;
  transition: color 300ms ease;
  cursor: pointer;
  margin-bottom: 6px;
}
.note-configurator .option-container__menu .menu-option:hover, .note-configurator .option-container__menu .menu-option.active {
  color: #8066FF;
}
.note-configurator .option-container__choices {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
}
.note-configurator .option-container__choices .choices-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  -ms-flex-line-pack: start;
  align-content: flex-start;
}
.note-configurator .option-container__choices .choice {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 30%;
  border: 1px solid rgba(112, 112, 112, 0.3019607843);
  border-radius: 8px;
  margin-bottom: 3%;
  overflow: hidden;
  cursor: pointer;
  margin-left: 3%;
}
.note-configurator .option-container__choices .choice .background {
  width: 100%;
  height: 100%;
  background-size: cover !important;
  min-height: 108px;
}
.note-configurator .option-container__choices .choice.color {
  border: 3px solid transparent;
}
.note-configurator .option-container__choices .choice.active {
  border: 3px solid #8066FF;
}
.note-configurator .option-container__choices .choice.font {
  margin-left: 0 !important;
  margin-right: 0 !important;
  border: 0 !important;
  font-size: 32px;
  height: 50px;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
}
.note-configurator .option-container__choices .choice.font.active {
  border: 0 !important;
  border-bottom: 2px solid #8066FF !important;
  border-radius: 0 !important;
}
.note-configurator .option-container__choices .choices-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  height: 22px;
  width: 100%;
  margin-top: 10px;
}
.note-configurator .option-container__choices .choices-pagination .pages {
  margin: 0 15px;
}
.note-configurator .option-container__choices .choices-pagination i {
  font-size: 20px;
  cursor: pointer;
  transition: color 300ms ease;
}
.note-configurator .option-container__choices .choices-pagination i.inactive {
  color: #eff0f1;
}
@media (max-width: 1024px) {
  .note-configurator .note-container {
    order: 1;
    margin-bottom: 40px;
  }
}
.note-configurator .note-container__text {
  margin-bottom: 30px;
  margin-top: 95px;
}
.note-configurator .note-container__text .input-container {
  position: relative;
  width: 330px;
}
@media (max-width: 1024px) {
  .note-configurator .note-container__text .input-container {
    width: 100%;
    max-width: 530px;
    margin: 0 auto;
  }
}
.note-configurator .note-container__text .input-container + .input-container {
  margin-top: 12px;
}
.note-configurator .note-container__text .input-container input {
  background: #EFF0F1;
  border-radius: 8px;
  border: 0;
  box-shadow: none;
  padding: 17px 15px;
  width: 100%;
}
.note-configurator .note-container__text .input-container .text-length {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  font-size: 12px;
}
.note-configurator .note-container__note {
  position: relative;
  max-width: 530px;
  overflow: hidden;
  margin: 0;
}
.note-configurator .note-container__note .inner {
  border-radius: 16px;
}
.note-configurator .note-container__note .inner #textBox {
  transition: opacity 0.3s ease-in-out;
}
.note-configurator .note-container__note .inner .text-box {
  padding-right: 20px;
  padding-left: 5px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.note-configurator .note-container__note .inner .text-box .text-row {
  white-space: nowrap;
  margin: 0;
  text-align: center;
  width: max-content;
}
.note-configurator .note-container__price {
  margin-top: 20px;
}
.note-configurator .note-container__price p {
  max-width: 425px;
}
@media (max-width: 1024px) {
  .note-configurator .note-container__price p {
    margin-bottom: 20px;
  }
}
@media (max-width: 1024px) {
  .note-configurator .note-container__price.desktop {
    display: none;
  }
}
.note-configurator .note-container__price.mobile {
  display: none;
}
@media (max-width: 1024px) {
  .note-configurator .note-container__price.mobile {
    order: 3;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    max-width: 530px;
    margin: 20px auto 0 auto;
  }
}
.note-configurator .note-container__price .price {
  display: inline-block;
  font-size: 32px;
  font-weight: bold;
  line-height: 1;
}
.note-configurator .note-container__price .extra-info {
  width: 100%;
  font-size: 24px;
  font-weight: normal;
}
@media (max-width: 1024px) {
  .note-configurator .note-container__price .extra-info {
    display: block;
    font-size: 18px;
  }
}
.note-configurator .note-container__price .button {
  display: inline-block;
  margin-left: 30px;
  background: #21ED9A;
  color: #333333;
  padding: 18px 27px;
  border-radius: 100px;
  line-height: 1;
  cursor: pointer;
  transition: background 300ms ease;
}
.note-configurator .note-container__price .button:hover {
  background: #10cb7f;
}`, "",{"version":3,"sources":["webpack://./js/assets/style.scss"],"names":[],"mappings":"AAQA;EACE,wBAAA;EACA,4CAAA;AAPF;AASA;EACE,sBAAA;EACA,4CAAA;AAPF;AASA;EACE,8BAAA;EACA,4CAAA;AAPF;AASA;EACE,qBAAA;EACA,4CAAA;AAPF;AASA;EACE,0BAAA;EACA,4CAAA;AAPF;AASA;EACE,0BAAA;EACA,4CAAA;AAPF;AASA;EACE,uCAAA;EACA,4CAAA;AAPF;AAUA;EACE,aAAA;EACA,8BAAA;AARF;AAUE;EAJF;IAKI,eAAA;EAPF;AACF;AAYQ;EACE,UAAA;AAVV;AAgBE;;EAEE,cAAA;EACA,UAAA;AAdJ;AAgBI;EALF;;IAMI,WAAA;IACA,gBAAA;IACA,cAAA;EAZJ;AACF;AAeE;EACE,aAAA;EACA,sBAAA;AAbJ;AAeI;EAJF;IAKI,QAAA;EAZJ;AACF;AAcI;EACE,aAAA;EACA,cAAA;AAZN;AAeI;EACE,aAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,oDAAA;EACA,mBAAA;AAbN;AAeM;EATF;IAUI,eAAA;EAZN;AACF;AAcM;EACE,cAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAjGC;EAkGD,mDAAA;EACA,eAAA;AAZR;AAcQ;EACE,mBAxGH;AA4FP;AAeQ;EACE,mBA1GD;EA2GC,cA/GF;AAkGR;AAkBI;EACE,YAAA;EACA,cAAA;AAhBN;AAkBM;EAJF;IAKI,YAAA;EAfN;AACF;AAiBM;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;AAfR;AAkBM;EACE,gBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;AAhBR;AAkBQ;EAEE,cAvID;AAsHT;AAsBI;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;AApBN;AAsBM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;AApBR;AAuBM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,mDAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AArBR;AAuBQ;EACE,WAAA;EACA,YAAA;EACA,iCAAA;EACA,iBAAA;AArBV;AAwBQ;EACE,6BAAA;AAtBV;AAyBQ;EACE,yBAAA;AAvBV;AA0BQ;EACE,yBAAA;EACA,0BAAA;EACA,oBAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,2BAAA;EACA,WAAA;AAxBV;AA0BU;EACE,oBAAA;EACA,2CAAA;EACA,2BAAA;AAxBZ;AA6BM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AA3BR;AA6BQ;EACE,cAAA;AA3BV;AA8BQ;EACE,eAAA;EACA,eAAA;EACA,4BAAA;AA5BV;AA8BU;EACE,cAAA;AA5BZ;AAoCI;EADF;IAEI,QAAA;IACA,mBAAA;EAjCJ;AACF;AAmCI;EACE,mBAAA;EACA,gBAAA;AAjCN;AAmCM;EACE,kBAAA;EACA,YAAA;AAjCR;AAmCQ;EAJF;IAKI,WAAA;IACA,gBAAA;IACA,cAAA;EAhCR;AACF;AAkCQ;EACE,gBAAA;AAhCV;AAmCQ;EACE,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAjCV;AAoCQ;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,eAAA;AAlCV;AAuCI;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AArCN;AAuCM;EACE,mBAAA;AArCR;AAuCQ;EACE,oCAAA;AArCV;AAwCQ;EACE,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAtCV;AAwCU;EACE,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;AAtCZ;AA4CI;EACE,gBAAA;AA1CN;AA4CM;EACE,gBAAA;AA1CR;AA4CQ;EAHF;IAII,mBAAA;EAzCR;AACF;AA6CQ;EADF;IAEI,aAAA;EA1CR;AACF;AA6CM;EACE,aAAA;AA3CR;AA+CQ;EADF;IAEI,QAAA;IACA,WAAA;IACA,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,eAAA;IACA,gBAAA;IACA,wBAAA;EA5CR;AACF;AA+CM;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA7CR;AAgDM;EACE,WAAA;EACA,eAAA;EACA,mBAAA;AA9CR;AAgDQ;EALF;IAMI,cAAA;IACA,eAAA;EA7CR;AACF;AAgDM;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,iCAAA;AA9CR;AAgDQ;EACE,mBAAA;AA9CV","sourcesContent":["$white: #FFFFFF;\r\n$black: #000000;\r\n$gray: #EFF0F1;\r\n\r\n$purple: #8066FF;\r\n$orange: #FF795A;\r\n$green: #21ed9a;\r\n\r\n@font-face {\r\n  font-family: 'Quicksand';\r\n  src: url(../../assets/fonts/Quicksand-Medium.ttf)\r\n}\r\n@font-face {\r\n  font-family: 'Allerta';\r\n  src: url(../../assets/fonts/Allerta-Regular.ttf)\r\n}\r\n@font-face {\r\n  font-family: 'Allerta Stencil';\r\n  src: url(../../assets/fonts/AllertaStencil-Regular.ttf)\r\n}\r\n@font-face {\r\n  font-family: 'Oswald';\r\n  src: url(../../assets/fonts/Oswald-VariableFont_wght.ttf)\r\n}\r\n@font-face {\r\n  font-family: 'Roboto Slab';\r\n  src: url(../../assets/fonts/RobotoSlab-VariableFont_wght.ttf)\r\n}\r\n@font-face {\r\n  font-family: 'Roboto Mono';\r\n  src: url(../../assets/fonts/RobotoMono-VariableFont_wght.ttf)\r\n}\r\n@font-face {\r\n  font-family: 'Annie use your telescope';\r\n  src: url(../../assets/fonts/AnnieUseYourTelescope-Regular.ttf)\r\n}\r\n\r\n.note-configurator {\r\n  display: flex;\r\n  justify-content: space-between;\r\n\r\n  @media (max-width: 1024px) {\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  &.small {\r\n    .option-container {\r\n      &__tabs {\r\n        .tab {\r\n          width: 50%;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .option-container,\r\n  .note-container {\r\n    flex: 0 0 auto;\r\n    width: 48%;\r\n\r\n    @media (max-width: 1024px) {\r\n      width: 100%;\r\n      max-width: 530px;\r\n      margin: 0 auto;\r\n    }\r\n  }\r\n\r\n  .option-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    @media (max-width: 1024px) {\r\n      order: 2;\r\n    }\r\n\r\n    &__content {\r\n      display: flex;\r\n      flex: 0 0 auto;\r\n    }\r\n\r\n    &__tabs {\r\n      display: flex;\r\n      flex: 0 0 auto;\r\n      width: 100%;\r\n      padding: 5px;\r\n      border-radius: 100px;\r\n      box-shadow: 0px 5px 10px #0000001A;\r\n      margin-bottom: 30px;\r\n\r\n      @media (max-width: 1024px) {\r\n        font-size: 13px;\r\n      }\r\n\r\n      .tab {\r\n        width: 33.334%;\r\n        padding: 15px 0;\r\n        border-radius: 100px;\r\n        flex: 0 0 auto;\r\n        text-align: center;\r\n        text-transform: uppercase;\r\n        font-weight: bold;\r\n        color: $purple;\r\n        transition: background 300ms ease, color 300ms ease;\r\n        cursor: pointer;\r\n\r\n        &:hover {\r\n          background: $gray;\r\n        }\r\n\r\n        &.active {\r\n          background: $purple;\r\n          color: $white;\r\n        }\r\n      }\r\n    }\r\n\r\n    &__menu {\r\n      width: 150px;\r\n      flex: 0 0 auto;\r\n\r\n      @media (max-width: 450px) {\r\n        width: 120px;\r\n      }\r\n\r\n      .svg-toggle {\r\n        display: flex;\r\n        justify-content: flex-start;\r\n        align-items: center;\r\n        gap: 10px;\r\n      }\r\n\r\n      .menu-option {\r\n        font-weight: 500;\r\n        transition: color 300ms ease;\r\n        cursor: pointer;\r\n        margin-bottom: 6px;\r\n\r\n        &:hover,\r\n        &.active {\r\n          color: $purple;\r\n        }\r\n      }\r\n    }\r\n\r\n    &__choices {\r\n      position: relative;\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n      flex: 1 1 auto;\r\n\r\n      .choices-container {\r\n        width: 100%;\r\n        height: 100%;\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        flex: 1 1 auto;\r\n        -ms-flex-line-pack: start;\r\n        align-content: flex-start\r\n      }\r\n\r\n      .choice {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        position: relative;\r\n        width: 30%;\r\n        border: 1px solid #7070704D;\r\n        border-radius: 8px;\r\n        margin-bottom: 3%;\r\n        overflow: hidden;\r\n        cursor: pointer;\r\n        margin-left: 3%;\r\n\r\n        .background {\r\n          width: 100%;\r\n          height: 100%;\r\n          background-size: cover !important;\r\n          min-height: 108px;\r\n        }\r\n\r\n        &.color {\r\n          border: 3px solid transparent;\r\n        }\r\n\r\n        &.active {\r\n          border: 3px solid $purple;\r\n        }\r\n\r\n        &.font {\r\n          margin-left: 0 !important;\r\n          margin-right: 0 !important;\r\n          border: 0 !important;\r\n          font-size: 32px;\r\n          height: 50px;\r\n          align-items: flex-start;\r\n          justify-content: flex-start;\r\n          width: 100%;\r\n\r\n          &.active {\r\n            border: 0 !important;\r\n            border-bottom: 2px solid $purple !important;\r\n            border-radius: 0 !important;\r\n          }\r\n        }\r\n      }\r\n\r\n      .choices-pagination {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        line-height: 1;\r\n        height: 22px;\r\n        width: 100%;\r\n        margin-top: 10px;\r\n\r\n        .pages {\r\n          margin: 0 15px;\r\n        }\r\n\r\n        i {\r\n          font-size: 20px;\r\n          cursor: pointer;\r\n          transition: color 300ms ease;\r\n\r\n          &.inactive {\r\n            color: #eff0f1;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .note-container {\r\n    @media (max-width: 1024px) {\r\n      order: 1;\r\n      margin-bottom: 40px;\r\n    }\r\n\r\n    &__text {\r\n      margin-bottom: 30px;\r\n      margin-top: 95px;\r\n\r\n      .input-container {\r\n        position: relative;\r\n        width: 330px;\r\n\r\n        @media (max-width: 1024px) {\r\n          width: 100%;\r\n          max-width: 530px;\r\n          margin: 0 auto;\r\n        }\r\n\r\n        &+.input-container {\r\n          margin-top: 12px;\r\n        }\r\n\r\n        input {\r\n          background: #EFF0F1;\r\n          border-radius: 8px;\r\n          border: 0;\r\n          box-shadow: none;\r\n          padding: 17px 15px;\r\n          width: 100%;\r\n        }\r\n\r\n        .text-length {\r\n          position: absolute;\r\n          top: 50%;\r\n          right: 15px;\r\n          transform: translateY(-50%);\r\n          font-size: 12px;\r\n        }\r\n      }\r\n    }\r\n\r\n    &__note {\r\n      position: relative;\r\n      max-width: 530px;\r\n      overflow: hidden;\r\n      margin: 0;\r\n\r\n      .inner {\r\n        border-radius: 16px;\r\n\r\n        #textBox {\r\n          transition: opacity 0.3s ease-in-out;\r\n        }\r\n\r\n        .text-box {\r\n          padding-right: 20px;\r\n          padding-left: 5px;\r\n          height: auto;\r\n          display: flex;\r\n          flex-direction: column;\r\n          align-items: center;\r\n\r\n          .text-row {\r\n            white-space: nowrap;\r\n            margin: 0;\r\n            text-align: center;\r\n            width: max-content;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    &__price {\r\n      margin-top: 20px;\r\n\r\n      p {\r\n        max-width: 425px;\r\n\r\n        @media (max-width: 1024px) {\r\n          margin-bottom: 20px;\r\n        }\r\n      }\r\n\r\n      &.desktop {\r\n        @media (max-width: 1024px) {\r\n          display: none;\r\n        }\r\n      }\r\n\r\n      &.mobile {\r\n        display: none;\r\n      }\r\n\r\n      &.mobile {\r\n        @media (max-width: 1024px) {\r\n          order: 3;\r\n          width: 100%;\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: space-between;\r\n          flex-wrap: wrap;\r\n          max-width: 530px;\r\n          margin: 20px auto 0 auto;\r\n        }\r\n      }\r\n\r\n      .price {\r\n        display: inline-block;\r\n        font-size: 32px;\r\n        font-weight: bold;\r\n        line-height: 1;\r\n      }\r\n\r\n      .extra-info {\r\n        width: 100%;\r\n        font-size: 24px;\r\n        font-weight: normal;\r\n\r\n        @media (max-width: 1024px) {\r\n          display: block;\r\n          font-size: 18px;\r\n        }\r\n      }\r\n\r\n      .button {\r\n        display: inline-block;\r\n        margin-left: 30px;\r\n        background: #21ED9A;\r\n        color: #333333;\r\n        padding: 18px 27px;\r\n        border-radius: 100px;\r\n        line-height: 1;\r\n        cursor: pointer;\r\n        transition: background 300ms ease;\r\n\r\n        &:hover {\r\n          background: darken(#21ED9A, 10%);\r\n        }\r\n      }\r\n    }\r\n\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
